/**
 * URL canonique du site (sitemap, robots, fallback OG absolu).
 * Définir REACT_APP_SITE_URL au build si le domaine de prod change.
 */
export const DEFAULT_SITE_URL =
  process.env.REACT_APP_SITE_URL || "https://hasnaoui-abdenacer.netlify.app";

export const PERSON_NAME = "Abdenacer Hasnaoui";

export const PERSON_SAME_AS = [
  "https://www.linkedin.com/in/abdenacer-hasnaoui-91bb86211/",
  "https://github.com/abdenacer1993",
  "https://www.facebook.com/hasnaoui1993/",
  "https://www.instagram.com/abdenacer_hasnaoui/",
];
